module.exports = __webpack_public_path__ + "img/54ne.a006a2e6.svg";